import React from 'react';

const Light = () => (
  <svg viewBox="0 0 1024 1024" width="32" height="32">
    <path
      d="M512 288c-123.488 0-224 100.512-224 224 0 123.488 100.512 224 224 224s224-100.512 224-224C736 388.512 635.488 288 512 288zM512 672c-88.384 0-160-71.616-160-160s71.616-160 160-160 160 71.616 160 160S600.384 672 512 672zM512 224c17.664 0 32-14.336 32-32L544 128c0-17.664-14.336-32-32-32s-32 14.336-32 32l0 64C480 209.664 494.336 224 512 224zM512 800c-17.664 0-32 14.336-32 32l0 64c0 17.664 14.336 32 32 32s32-14.336 32-32l0-64C544 814.336 529.664 800 512 800zM760.864 308.32l45.248-45.248c12.512-12.512 12.512-32.736 0-45.248-12.512-12.512-32.736-12.512-45.248 0l-45.248 45.248c-12.512 12.512-12.512 32.736 0 45.248C728.128 320.832 748.384 320.832 760.864 308.32zM263.136 715.68l-45.248 45.248c-12.512 12.512-12.512 32.736 0 45.248s32.736 12.512 45.248 0l45.248-45.248c12.512-12.544 12.512-32.768 0-45.248C295.872 703.168 275.616 703.136 263.136 715.68zM224 512c0-17.664-14.336-32-32-32L128 480c-17.664 0-32 14.336-32 32s14.336 32 32 32l64 0C209.664 544 224 529.664 224 512zM896 480l-64 0c-17.664 0-32 14.336-32 32s14.336 32 32 32l64 0c17.664 0 32-14.336 32-32S913.664 480 896 480zM263.072 308.32c12.512 12.512 32.768 12.512 45.248 0 12.512-12.512 12.512-32.736 0-45.248l-45.248-45.248c-12.512-12.512-32.736-12.512-45.248 0-12.512 12.512-12.512 32.736 0 45.248L263.072 308.32zM760.928 715.616c-12.544-12.512-32.768-12.512-45.248 0-12.512 12.512-12.544 32.736 0 45.248l45.248 45.248c12.512 12.512 32.736 12.512 45.248 0s12.512-32.736 0-45.248L760.928 715.616z"
      p-id="3362"
    />
  </svg>
);

const Dark = () => (
  <svg viewBox="0 0 1024 1024" width="32" height="14">
    <path
      d="M556.8 979.2c-262.4 0-473.6-211.2-473.6-467.2s211.2-467.2 467.2-467.2c12.8 0 19.2 6.4 25.6 12.8 6.4 12.8 6.4 19.2 0 32-57.6 70.4-83.2 160-83.2 249.6 0 230.4 185.6 416 416 416h6.4c12.8 0 19.2 6.4 25.6 12.8 6.4 12.8 6.4 19.2 0 32a498.56 498.56 0 0 1-384 179.2z m-64-876.8c-198.4 32-352 204.8-352 409.6 0 230.4 185.6 416 416 416 108.8 0 211.2-44.8 288-121.6-236.8-25.6-416-230.4-416-467.2 0-89.6 25.6-166.4 64-236.8z"
      fill=""
      p-id="4160"
    />
    <path
      d="M582.4 883.2c-192 0-352-134.4-384-320 0-6.4 6.4-12.8 12.8-19.2 6.4 0 12.8 6.4 19.2 12.8 32 172.8 179.2 294.4 352 294.4 6.4 0 12.8 6.4 12.8 12.8 0 12.8-6.4 19.2-12.8 19.2zM204.8 531.2c-6.4 0-12.8-6.4-12.8-12.8v-19.2c0-6.4 6.4-12.8 12.8-12.8s12.8 6.4 12.8 12.8v19.2c6.4 6.4 0 12.8-12.8 12.8z"
      fill=""
      p-id="4161"
    />
    <path
      d="M620.8 307.2m-25.6 0a25.6 25.6 0 1 0 51.2 0 25.6 25.6 0 1 0-51.2 0Z"
      fill=""
      p-id="4162"
    />
    <path
      d="M793.6 185.6m-25.6 0a25.6 25.6 0 1 0 51.2 0 25.6 25.6 0 1 0-51.2 0Z"
      fill=""
      p-id="4163"
    />
    <path
      d="M736 416m-25.6 0a25.6 25.6 0 1 0 51.2 0 25.6 25.6 0 1 0-51.2 0Z"
      fill=""
      p-id="4164"
    />
  </svg>
);

export default {
  Light,
  Dark,
};
